import React, { useEffect, useState } from 'react';
import { WarningAmberOutlined } from '@mui/icons-material';
import { ProblemListItem } from '~/components/carePlan/ProblemList/ProblemListItem';
import Button from '@mui/material/Button';
import { AddProblemListModal } from '~/components/carePlan/ProblemList/AddProblemListModal';
import { useQueryClient } from 'react-query';
export const ProblemListBox = (props) => {
    const [problems, setProblems] = useState(props.problemList);
    const [problemToEdit, setProblemToEdit] = useState(undefined);
    const [showAddModal, setShowAddModal] = useState(false);
    const queryClient = useQueryClient();
    useEffect(() => {
        setProblems(props.problemList);
    }, [props.problemList]);
    // Calculate the most recent update date
    const getLatestUpdateDate = () => {
        if (problems.length === 0) {
            return '';
        }
        const latestDate = problems.reduce((latest, problem) => {
            const problemLatest = problem.updatedAt > problem.createdAt
                ? problem.updatedAt
                : problem.createdAt;
            return problemLatest > latest ? problemLatest : latest;
        }, new Date(0));
        return latestDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const handleEdit = (id) => {
        setProblemToEdit(problems.find(obj => obj.id === id));
        setShowAddModal(true);
    };
    const handleDelete = (id) => {
        setProblems(prev => prev.filter(problem => problem.id !== id));
        queryClient.invalidateQueries(['getPatientTimeline', props.patientId]);
    };
    const onAddEntry = () => {
        setProblemToEdit(undefined);
        setShowAddModal(true);
    };
    const handleProblemSuccess = (updatedProblem) => {
        if (problemToEdit) {
            // Edit: Update existing problem in the list
            setProblems(prev => prev.map(problem => problem.id === updatedProblem.id ? updatedProblem : problem));
        }
        else {
            // Add: Append new problem to the list
            setProblems(prev => [...prev, updatedProblem]);
        }
        setShowAddModal(false);
        queryClient.invalidateQueries(['getPatientTimeline', props.patientId]);
    };
    return (React.createElement("div", { style: { width: '100%', height: '100%', background: 'white', borderRadius: 6, outline: '1px var(--elevation-outlined, #E0E0E0) solid', outlineOffset: '-1px', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', gap: 7, display: 'inline-flex' } },
        showAddModal &&
            React.createElement(AddProblemListModal, { onRequestClose: () => setShowAddModal(false), problemToEdit: problemToEdit ? problemToEdit : null, patientId: props.patientId, onSuccess: handleProblemSuccess, presets: props.presets }),
        React.createElement("div", { style: { padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' } },
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                React.createElement(WarningAmberOutlined, { style: { color: '#0000008A', height: '20px', width: '20px' } }),
                React.createElement("span", { style: { fontSize: 14, color: '#000000DE', fontFamily: 'Barlow', fontWeight: '600', } }, "Problem List")),
            React.createElement("div", { style: { fontSize: 12, color: '#00000099', fontFamily: 'Barlow', fontWeight: '500' } },
                problems.length > 0 && 'Updated: ',
                " ",
                getLatestUpdateDate())),
        React.createElement("div", { style: { paddingLeft: '16px' } },
            React.createElement(Button, { variant: "outlined", onClick: onAddEntry, disabled: props.isAddDisabled, style: { textTransform: 'none', borderRadius: '20px', height: '30px' } }, "Add Entry")),
        React.createElement("div", { style: {
                flex: 1,
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
            }, className: "problem-list-scroll" }, problems.map((item) => (React.createElement(ProblemListItem, { key: item.id, item: item, onEdit: handleEdit, onDelete: handleDelete, isEditDisabled: props.isAddDisabled }))))));
};
export const fakeProblemList = [
    {
        id: 1,
        carePlanId: 101,
        patientId: 501,
        month: '2023-10',
        isEditable: true,
        problemName: 'Hypertension',
        problemDescription: 'Diagnosed in 2011',
        createdAt: new Date('2023-10-15T10:30:00'),
        updatedAt: new Date('2023-10-26T14:22:00'),
        deletedAt: null
    },
    {
        id: 2,
        carePlanId: 101,
        patientId: 501,
        month: '2023-10',
        isEditable: true,
        problemName: 'Type 2 Diabetes',
        problemDescription: 'Notes notes notes notes',
        createdAt: new Date('2023-10-20T09:15:00'),
        updatedAt: new Date('2023-10-20T09:15:00'),
        deletedAt: null
    },
    {
        id: 3,
        carePlanId: 101,
        patientId: 501,
        month: '2023-10',
        isEditable: true,
        problemName: 'Asthma',
        problemDescription: 'Notes notes notes notes',
        createdAt: new Date('2023-09-05T16:45:00'),
        updatedAt: new Date('2025-10-12T11:30:00'),
        deletedAt: null
    },
    {
        id: 4,
        carePlanId: 101,
        patientId: 501,
        month: '2023-10',
        isEditable: true,
        problemName: 'Chronic Lower Back Pain',
        problemDescription: 'Ongoing management with physical therapy',
        createdAt: new Date('2023-08-22T13:20:00'),
        updatedAt: new Date('2023-10-18T10:05:00'),
        deletedAt: null
    },
    {
        id: 5,
        carePlanId: 101,
        patientId: 501,
        month: '2023-10',
        isEditable: false,
        problemName: 'Seasonal Allergies',
        problemDescription: 'Mild symptoms, managed with OTC antihistamines',
        createdAt: new Date('2023-07-10T08:00:00'),
        updatedAt: new Date('2023-07-10T08:00:00'),
        deletedAt: null
    }
];
